import { Person, Topic, TopicExpertise } from "@shapeable/gesda-types";
import { maxBy, toNumber, toString } from 'lodash';

export const useCurrentEditionMembers = (committeeMembers: Person[], topic?: Topic) => {
  const currentYear = new Date().getFullYear();
  const currentEdition = maxBy(topic?.editions, e => e.numericValue || toNumber(e.name));
  
  const membersByEdition = committeeMembers.filter((member) => 
    member.topicExpertise.some((expertise: TopicExpertise) => 
      expertise?.topic?.id === topic?.id &&
      expertise.editions.some(e => toString(e.name) === toString(currentEdition?.name || currentYear)))
  );
  return membersByEdition;
  // return committeeMembers.filter(member => member.badge?.includes(toString(currentEdition?.name || currentYear)));

}